<template>
  <v-card color="white" class="pb-4 mb-2">
    <v-card-actions flat class="sstruct-top-actions">
      <v-icon>mdi-drag</v-icon>
      <v-spacer></v-spacer>
      <v-menu :close-on-click="true" :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-alarm-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-subtitle>Тайминг</v-card-subtitle>
          <v-text-field class="ml-2 mr-2" outlined placeholder="Время на блок" solo v-model="SStruct.timing">
          </v-text-field>
          <template v-if="timing in SStruct.type">
            <v-card-text>~{{ Sstruct.type.timing }}</v-card-text>
          </template>
        </v-card>
      </v-menu>
      <v-btn icon @click="openSStructTextEdit = true">
        <v-icon>mdi-comment-edit</v-icon>
      </v-btn>
      <v-btn icon @click="$emit('delete')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <s-struct-type-info
      :s-struct-type="SStruct.type">
    </s-struct-type-info>
    <v-card flat class="ma-2 sstruct-text pa-4">
      <span v-html="SStruct.text"></span>
    </v-card>
    <v-dialog v-model="openSStructTextEdit" max-width="60%">
      <s-struct-text-edit
        :s-struct-text="SStruct.text"
        @save="updateSStructText"
        @cancel="openSStructTextEdit = false">
      </s-struct-text-edit>
    </v-dialog>
  </v-card>
</template>

<script>
import SStructTypeInfo from './SStructTypeInfo'
import SStructTextEdit from './SStructTextEdit'

/***
 * presentation and actions on the speech struct
 * @description use with prop {Object} SStruct - speech struct
 */

export default {
  name: 'SStruct',
  components: { SStructTextEdit, SStructTypeInfo },
  props: {
    SStruct: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      openSStructTextEdit: false,
      timing: ''
    }
  },
  methods: {
    updateSStructText (newText) {
      this.SStruct.text = newText
      this.openSStructTextEdit = false
    }
  }
}
</script>

<style scoped>
  .sstruct-text,
  .sstruct-top-actions{
    background-color: whitesmoke!important;
  }
</style>
